var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolsClrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#F5FBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.58269 19.0003H7.4577C6.26604 19.0003 5.66602 18.4003 5.66602 17.2086V7.45868C5.66602 6.26701 6.26604 5.66699 7.4577 5.66699H11.041C12.2327 5.66699 12.8327 6.26701 12.8327 7.45868V9.00033",
    stroke: "#74C2FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4756 11.0167V20.3167C18.4756 21.6583 17.809 22.3333 16.4673 22.3333H11.6006C10.259 22.3333 9.58398 21.6583 9.58398 20.3167V11.0167C9.58398 9.67499 10.259 9 11.6006 9H16.4673C17.809 9 18.4756 9.67499 18.4756 11.0167Z",
    stroke: "#74C2FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.166 9.00033V7.45868C15.166 6.26701 15.766 5.66699 16.9577 5.66699H20.541C21.7326 5.66699 22.3327 6.26701 22.3327 7.45868V17.2086C22.3327 18.4003 21.7326 19.0003 20.541 19.0003H18.4743",
    stroke: "#74C2FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.334 13.167H15.6673",
    stroke: "#74C2FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.334 15.667H15.6673",
    stroke: "#74C2FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.333V19.833",
    stroke: "#74C2FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 3.5,
    stroke: "#74C2FF",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolsClrIcon);
export default __webpack_public_path__ + "static/media/schools-clr-icon.b594e6b2581aa32c0c8f1cf6359e4ca1.svg";
export { ForwardRef as ReactComponent };